import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { LinkList } from '@gumtree/ui-library';
import { trackGA4AndNavigate, trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';
import WithVisibilityObserver from '@gumtree/shared/src/util/element-visibility/visibility-observer';
import { getLinkHostname } from '@gumtree/shared/src/util/ga4-bff';
import { getClinetPageCategories } from '@gumtree/shell/src/utils';

import { Container } from './link-recommender.style';
import type { SrpState } from '../../reducers';

export function LinkRecommender() {
    const links = useSelector(
        ({ resultsPage: { linkRecommenderList } }: SrpState) =>
            Array.isArray(linkRecommenderList) ? linkRecommenderList : [],
        shallowEqual
    );
    const mappedLinks = links.map(({ url, name }) => ({ text: name, href: url }));
    function onVisible() {
        trackGA4Event<GA4.BrowseLinksEvent>({
            event: 'link_impress',
            linkLocation: 'related',
            linkType: 'inside',
            linkURL: links.map((i) => i.url).join(','),
            linkId: links.map((i) => i.id).join(','),
            linkText: links.map((i) => i.name).join(','),
            linkDomain: links.map((i) => getLinkHostname(i.url)).join(','),
            linkDetail: {
                category: links.map((i) => i.leafCategoryName).join(','),
                categoryId: links.map((i) => i.leafCategoryId).join(','),
                subcategory1: links.map((i) => i.categoryIds?.[0] || '').join(','),
                subcategory2: links.map((i) => i.categoryIds?.[1] || '').join(','),
                subcategory3: links.map((i) => i.categoryIds?.[2] || '').join(','),
                subcategory4: links.map((i) => i.categoryIds?.[3] || '').join(','),
                subcategory5: links.map((i) => i.categoryIds?.[4] || '').join(','),
            },
            listLinkDetail: getClinetPageCategories(),
        });
    }
    if (!mappedLinks.length) {
        return null;
    }

    return (
        <WithVisibilityObserver onVisible={onVisible}>
            <Container data-testid="link-recommender">
                <LinkList
                    items={mappedLinks}
                    onClickItem={(e, item, index) => {
                        const curLink = links[index];
                        trackGA4AndNavigate<GA4.BrowseLinksEvent>({
                            mouseEvent: e,
                            href: item.href,
                            payload: {
                                event: 'link_click',
                                linkDomain: getLinkHostname(item.href),
                                linkText: item.text,
                                linkType: 'inside',
                                linkURL: item.href,
                                linkId: curLink.id,
                                linkLocation: 'related',
                                listLinkDetail: getClinetPageCategories(),
                                linkPosition: index + 1,
                                linkDetail: {
                                    category: curLink.leafCategoryName,
                                    categoryId: curLink.leafCategoryId,
                                    subcategory1: curLink?.categoryIds?.[0] || '',
                                    subcategory2: curLink?.categoryIds?.[1] || '',
                                    subcategory3: curLink?.categoryIds?.[2] || '',
                                    subcategory4: curLink?.categoryIds?.[3] || '',
                                    subcategory5: curLink?.categoryIds?.[4] || '',
                                },
                            },
                        });
                    }}
                />
            </Container>
        </WithVisibilityObserver>
    );
}
